{
  "eyebrow": "Wählen Sie Ihren Tarif",
  "title": "Der Tarif, der zu Ihrem Team passt.",
  "sub": "30 Tage kostenlose Testphase für jeden Tarif. Keine Kreditkarte nötig. Jederzeit kündbar.",
  "bill": {
    "month": "Monatlich",
    "year": "Jährlich",
    "save": "~17% sparen"
  },
  "fam": {
    "time": "Zeit & Betrieb",
    "project": "Projekt- & Kostenkontrolle"
  },
  "compare": "Alle Funktionen vergleichen",
  "compareHide": "Vergleich ausblenden",
  "included": "Enthalten",
  "select": "{{plan}} auswählen",
  "selected": "Ausgewählt",
  "recommended": "Am beliebtesten",
  "pricePerMonth": "/ Nutzer / Monat",
  "pricePerYear": "/ Benutzer / Jahr",
  "base": "Grundpreis / Monat",
  "admins": "2 Administratoren inklusive",
  "continueCta": "Mit {{plan}} fortfahren",
  "continuePick": "Wählen Sie einen Tarif, um fortzufahren",
  "catalogError": "Preiskatalog nicht verfügbar. Erneut versuchen, um die aktuellen Preise zu laden.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Compliance & einfache Erfassung",
    "timeProBest": "Teambetrieb",
    "projectBasicBest": "Projekt- & Kostenkontrolle",
    "projectProBest": "Erweitertes Projektmanagement",
    "feat": {
      "timeBasic": {
        "timeTracking": "Zeiterfassung",
        "absencesHolidays": "Abwesenheiten & Urlaub",
        "transport": "Transport-Protokolle",
        "workLocations": "Arbeitsorte & GPS",
        "mobileApp": "Mobile App für Außendienstmitarbeiter"
      },
      "timePro": {
        "everythingTime": "Alles aus Time Basic",
        "overtime": "Überstundenerfassung",
        "scheduling": "Schichtplanung",
        "documents": "Personaldokumente",
        "officeOps": "Office-Funktionen (Aktivitätsprotokoll, Korrekturen)",
        "addonsAvailable": "Verfügbare Add-ons: Projektverfolgung, VTT",
        "internalMessaging": "Interne Nachrichten (Chat)"
      },
      "projectBasic": {
        "everythingTime": "Alles aus Time Basic",
        "projects": "Projekte mit Kostenkontrolle",
        "extras": "Zusatzarbeit & Zusatzmaterial",
        "subcontractors": "Subunternehmer-Verwaltung",
        "checkInOut": "Mitarbeiter-Check-in / Check-out",
        "internalMessaging": "Interne Nachrichten (Chat)"
      },
      "projectPro": {
        "everythingAll": "Alles aus Time Pro + Project Basic",
        "projectTransport": "Projektgebundener Transport",
        "fullSuite": "Vollständige Produktivitäts-Suite",
        "prioritySupport": "Priorisierter Support",
        "internalMessaging": "Interne Nachrichten (Chat)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Alle Funktionen vergleichen",
    "subtitle": "Alles, was jeder Tarif enthält, im direkten Vergleich.",
    "cat": {
      "timeAttendance": "Zeit & Anwesenheit",
      "projectCost": "Projekt & Kostenkontrolle",
      "support": "Support"
    },
    "val": {
      "upTo4": "Bis zu 4",
      "unlimited": "Unbegrenzt",
      "soon": "Bald",
      "optional": "Optional",
      "years5": "5 Jahre",
      "years10": "10 Jahre"
    },
    "row": {
      "mobileDesktop": "Mobile & Desktop-App",
      "gpsCheckin": "Einchecken per Fingertipp mit GPS",
      "holidayAbsenceOvertime": "Urlaub, Abwesenheit & Überstunden",
      "teamMembers": "Teammitglieder",
      "workLocations": "Arbeitsorte",
      "registrationsPerMonth": "Registrierungen / Benutzer / Monat",
      "irregularMap": "Unregelmäßiges Ein-/Auschecken auf Karte",
      "expenseManagement": "Spesenverwaltung",
      "employeeDocuments": "Mitarbeiterdokumente",
      "openApi": "Offene API",
      "navigation": "Navigation zu Arbeitsorten",
      "projectManagement": "Projektmanagement (Budget)",
      "subprojects": "Unterprojekte",
      "subcontractorManagement": "Subunternehmerverwaltung",
      "extraWorkMaterials": "Zusatzarbeiten & Materialien",
      "transportProjects": "Transport mit Projekten verknüpft",
      "fullSuite": "Vollständige Produktivitätssuite",
      "prioritySupport": "Prioritäts-Support",
      "schedulingMessaging": "Planung · Nachrichten · Benachrichtigungen",
      "languages12": "In 12 Sprachen verfügbar",
      "manualTransport": "Manuelle Transportdistanz",
      "reportsExcel": "Berichte & Excel-Export",
      "frontendLocations": "Von App-Nutzern erstellte Standorte",
      "checkInWork": "Check-in/out@work (Belgien)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Projektbeschreibungen & Bilder",
      "dataStorage": "Datenspeicherung"
    }
  }
}
